module.exports = __webpack_public_path__ + "img/kt4.24b671e1.png";